import { render } from "./HeadShopHome.vue?vue&type=template&id=a639857c"
import script from "./HeadShopHome.vue?vue&type=script&lang=js"
export * from "./HeadShopHome.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__